
export default function getUserDetails(state) {
  return state.user;
}
